import { Pipe, PipeTransform } from '@angular/core';
import {
    ProductSearchViewModel,
    ProductSearchViewModelGenericSearchResultViewModel as ProductSearchResult
} from '@models/api-search.models';
import { RelewiseRetailMediaPlacement } from '@core/services/relewise/relewise-tracking.model';
import { mergeWithRetailMediaHelper } from '@core/services/relewise/merge-with-retail-media.helper';

@Pipe({
    name: 'mergeWithRetailMedia',
    standalone: true
})
export class MergeWithRetailMediaPipe implements PipeTransform {
    transform(value: ProductSearchResult, placement: RelewiseRetailMediaPlacement = 'TOP'): ProductSearchViewModel[] {
        return mergeWithRetailMediaHelper(value, placement);
    }
}
